<template>
  <div>
    <Table
      :list="list"
      :loading="isLoading"
    />
    <v-layout row justify-end class="my-2 px-5">
      <a class="ViewLink" @click.stop="onGoToAllActions">Смотреть все действия с процедурой</a>
    </v-layout>
  </div>
</template>

<script>
import Table from './Table.vue'

import { MARKS_ROUTES as ROUTES } from '@/views/Marks/utils'
import { EventLogApi } from '@/api/resources/Marks'

export default {
  components: {
    Table,
  },
  props: {
    procedureId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    list: [],
    isLoading: false,
  }),
  mounted() {
    this.onGetData()
  },
  methods: {
    async onGetData() {
      const api = new EventLogApi()
      this.isLoading = true
      try {
        const { data } = await api.getAll({
          procedure_id: this.procedureId,
        })
        if (Array.isArray(data)) {
          this.list = data
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onGoToAllActions() {
      const { procedureId: procedure_id } = this
      this.$router.push({
        name: ROUTES.ACTIONS,
        query: {
          procedure_id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ViewLink {
  font-style: italic;
  color: $color-info;
  text-decoration: underline;
}
</style>
